// Errors thrown by browser extensions (e.g. "chrome: call method timed out")
// are not from this app, but CRA's dev overlay still shows them. Swallow only
// those; every other error behaves normally.
const EXTENSION_PATTERN = /(chrome|moz|safari(-web)?)-extension:\/\//;

const isFromExtension = (...sources) =>
  sources.some((s) => typeof s === "string" && EXTENSION_PATTERN.test(s));

window.addEventListener(
  "error",
  (event) => {
    if (isFromExtension(event.filename, event.error?.stack, event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event.reason;
    if (isFromExtension(reason?.stack, reason?.message, String(reason))) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);
